import { render, staticRenderFns } from "./my-top-curved-bg.vue?vue&type=template&id=22c1e638&scoped=true&"
import script from "./my-top-curved-bg.vue?vue&type=script&lang=js&"
export * from "./my-top-curved-bg.vue?vue&type=script&lang=js&"
import style0 from "./my-top-curved-bg.vue?vue&type=style&index=0&id=22c1e638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1e638",
  null
  
)

export default component.exports